import {Injectable} from '@angular/core';
import {BaseService} from '../services/base-service.service';
import {HttpClient, HttpResponse} from '@angular/common/http';
import { ConsultaPaginada, ConsultaPaginadaResultado } from 'maestro-ng';
import {Particionamento} from './particionamento.model';
import {firstValueFrom} from 'rxjs';

@Injectable()
export class ParticionamentoService extends BaseService<Particionamento, String> {

  constructor(http: HttpClient) {
    super('particionamento', http);
  }

  public gerenciarParticionamentoTabela(particionamento: Particionamento): Promise<HttpResponse<string>> {
    return firstValueFrom(this.http.patch(this.path(`gerenciarParticionamento/${(particionamento.tabela)}`), undefined, { responseType: 'text', observe: 'response'  }));
  }
  public gerenciarParticionamento(): Promise<HttpResponse<string>> {
    return firstValueFrom(this.http.patch(this.path('gerenciarParticionamento'), undefined, { responseType: 'text', observe: 'response'  }));
  }
  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<Particionamento>> {
    return this.service.recuperarPaginado(consulta);
  }
}
